import {AuthToken, AuthTokenFields} from "../../types/user/authData";

class AuthTokenStorage {
    keyStorage = "onboardingAuthTokenStorage";
    keyStorageExpirationTime = "onboardingAuthTokenStorageExpirationTime";
    keyStorageExpirationTimeDate = "onboardingAuthTokenStorageExpirationTimeDate";

    public save(token: AuthToken) {
        const jwtToken = token[AuthTokenFields.AuthToken]
        const jwtParts = jwtToken.split('.');
        const payload = JSON.parse(atob(jwtParts[1]));

        localStorage.setItem(this.keyStorage, jwtToken);
        localStorage.setItem(this.keyStorageExpirationTime, token[AuthTokenFields.ExpirationTime].toString());
        localStorage.setItem(this.keyStorageExpirationTimeDate, new Date(payload.exp * 1000).toISOString());
    }

    public get(): string | null {
        return localStorage.getItem(this.keyStorage)
    }

    public getExpirationTime() {
        const expirationTime = parseInt(localStorage.getItem(this.keyStorageExpirationTime) || '');
        
        return expirationTime;
    }

    public getExpirationTimeDate() {
        const expirationTimeDateString = localStorage.getItem(this.keyStorageExpirationTimeDate);
        
        return new Date(expirationTimeDateString ? expirationTimeDateString : 0);
    }

    public removeFromStorage() {
        localStorage.removeItem(this.keyStorage);
        localStorage.removeItem(this.keyStorageExpirationTime);
        localStorage.removeItem(this.keyStorageExpirationTimeDate);
    }
}

export const authTokenStorage = new AuthTokenStorage();